"use client";
import { useState as u, useEffect as n } from "react";
import { registerStoryblokBridge as c } from "./storyblok-js.mjs";
const g = (e = null, o = {}) => {
  const [r, s] = u(e), d = (e == null ? void 0 : e.id) ?? 0, t = typeof window < "u" && typeof window.storyblokRegisterEvent < "u";
  return n(() => {
    s(e), !(!t || !e) && c(
      d,
      (f) => s(f),
      o
    );
  }, [e]), r;
};
export {
  g as useStoryblokState
};
